// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__JzuvA","dragIcon":"Choice_dragIcon__js8vw","left":"Choice_left__3SI_4","input":"Choice_input__105y2"};